import { render, staticRenderFns } from "./product-target-picker.vue?vue&type=template&id=2713e51e&scoped=true&"
import script from "./product-target-picker.vue?vue&type=script&lang=js&"
export * from "./product-target-picker.vue?vue&type=script&lang=js&"
import style0 from "./product-target-picker.vue?vue&type=style&index=0&id=2713e51e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2713e51e",
  null
  
)

export default component.exports